<fieldset>
 <legend>
  TypeObjCPV
 </legend>
 <button class="btn btn-outline-primary" (click)="addtypeCPVClass()">Ajouter un typeCPVClass</button>
<div *ngFor="let obj of cPV.objetComplementaire; let i = index">
  <fieldset>
    <legend>
      typeCPVClass {{ i + 1}}
    </legend>
    <button class="btn btn-outline-primary" (click)="removetypeCPVClass(i)">Supprimer un typeCPVClass</button>
    <app-typeCPV-class [uid]="getUid()+'_index_'+(i+1)" [parentForm]="parentForm"
[disabled]="disabled"
 [objetComplementaire]="obj"></app-typeCPV-class>
  </fieldset>
</div>

<fieldset>
  <legend>
    objetPrincipal
  </legend>
  <app-typeCPV-class [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [objetComplementaire]="cPV.objetPrincipal"></app-typeCPV-class>
</fieldset>

</fieldset>